import * as React from 'react';
import {
  Box,
  Button,
  Heading,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure
} from '@chakra-ui/react';
import { useState } from 'react';
import FFLSelect from './components/FFLSelect';
import ManageUsers from './components/ManageUsers';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { RouteParams } from '../common/types';
import StoreProfile from './components/StoreProfile';
import BlacklistDealers from './components/BlacklistDealers';
import FFLSelectFiltersConfiguration from './components/FFLSelectFiltersConfiguration';
import * as constants from '@/utils/constants';
import ManageDealerProfile from './components/ManageDealerProfile';
import ManageParameters from './components/ManageParameters';
import PreferredDealersReport from './components/PreferredDealersReport';
import {
  getIsEditabledTermsAndConditionsEnabled,
  getIsStoreFilterConfigChanged,
  getIsTermsAndConditionsChanged,
  getIsTermsAndConditionsUpdated,
  getIsUpdatingFilterConfig,
  getStoreTermsAndConditions,
  getUpdatedStoreFilterConfig
} from './ducks/selectors';
import { useDispatch } from 'react-redux';
import {
  callToUpdateStoreFilterConfig,
  callToUpdateStoreTermsAndConditions,
  setIsEditableTermsAndContionsEnabled,
  setIsStoreFilterConfigChanged,
  setIsTermsAndCondtionChanged,
  setIsTermsAndCondtionUpdated,
  setIsUpdatingFilterConfig
} from './ducks/slice';
import {
  getCurrentUserGroup,
  getIsGlobalAdminRole,
  getIsImpersonating,
  getIsPreferredReportsRole,
  getIsStoreAdmin,
  getIsStoreAgent
} from '@/redux/app-selectors'
import ManageTermsAndConditions from './components/ManageTermsAndConditions';
import FFLStripeConfiguration from './components/FFLStripeConfiguration';
import StockingDealers from './components/StockingDealers';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
import Permissions from './components/permissions';
import CustomWebhook from './components/CustomWebhook';
import EcommerceStatusMapping from './components/EcommerceStatusMapping';
import { getIsPermissionChanged, getIsPermissionLoading, getIsPermissionUpdateLoading, getPermissionConfig } from '@/queue/ducks/selectors';
import { callToUpdatePermissionsTabsList, setIsPermissionChanged, setIsPermissionReset } from '@/queue/ducks/slice';
import { getAdminTabPath, getFormattedAdminTabs, getHideSubTabs } from '@/utils/utils';

const adminTabNames: RouteParams = {
  'manage-dealer-profile': '0',
  'manage-users': '1',
  'fflselect': '2',
  'blacklist-dealers': '3',
  'upload-preferred-dealers': '4',
  'upload-stocking-dealers': '5',
  'manage-parameters': '6',
  'preferred-dealers-report': '7',
  'manage-terms-and-conditions': '8',
  'permissions': '9',
  'enriched-webhook': '10',
  'admin': '11',
  'ffl-stripe-configuration': '12',
};

// Note: if you add any route here please also add that object in the adminTabs in constants.ts file. that is related to permission tabs.
const adminTabNamesForStoreAdmin: RouteParams = {
  'manage-dealer-profile': '0',
  'manage-users': '1',
  'fflselect': '2',
  'blacklist-dealers': '3',
  'upload-preferred-dealers': '4',
  'upload-stocking-dealers': '5',
  'manage-parameters': '6',
  'preferred-dealers-report': '7',
  'manage-terms-and-conditions': '8',
  'enriched-webhook': '9',
  'admin': '10',
  // 'permissions': '8',


}
const adminTabNamesForPreferredReportsAdmin: RouteParams = {
  'upload-preferred-dealers': '0',
  'preferred-dealers-report': '1',
}
function StoreAdmin({ userPermissions }: any) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [refetch, setRefetch] = useState<number>(2);
  const [fflSelectTab, setFFLSelectTab] = useState<number>(0);
  const [callAPI, setCallAPI] = useState<boolean>(false);
  const { tabName } = useParams<RouteParams>();
  const isFilterConfigChanged = getIsStoreFilterConfigChanged();
  const updatedStoreFilterConfig = getUpdatedStoreFilterConfig();
  const isTermsAndConditionUpdated = getIsTermsAndConditionsUpdated();
  const isTermsAndConditionChanged = getIsTermsAndConditionsChanged();
  const [editorValue, setEditorValue] = useState("")
  const isEditabledTermsAndConditionsEnabled =
    getIsEditabledTermsAndConditionsEnabled();
  const storeTermsAndConditions = getStoreTermsAndConditions();
  const isUpdatingFilterConfig = getIsUpdatingFilterConfig();
  const isImpersonating = getIsImpersonating();
  const isGlobalAdminRole = getIsGlobalAdminRole();
  const isPreferredReportsRole = getIsPreferredReportsRole();
  const currentUserGroup = getCurrentUserGroup();
  const isStoreAdmin = getIsStoreAdmin()
  const isStoreAgent = getIsStoreAgent()
  const canViewEcommerceStatusMapping =
    isGlobalAdminRole && isImpersonating;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isPermissionsListLoading = getIsPermissionLoading()
  const isPermissionsUpdateLoading = getIsPermissionUpdateLoading()
  const permissionConfig = getPermissionConfig()
  const isPermissionChanged = getIsPermissionChanged()



  const onCancelFilterChanges = () => {
    setCallAPI(true);
    dispatch(setIsStoreFilterConfigChanged(false));
  };
  const onUpdateFilterConfig = () => {
    logAnalyticsEvent(analyticsEvents.updateFFLSelectFiltersConfig);
    dispatch(setIsUpdatingFilterConfig(true));
    dispatch(callToUpdateStoreFilterConfig(updatedStoreFilterConfig));
  };

  const onCancelTermsAndCondition = () => {
    setEditorValue(storeTermsAndConditions.terms_and_conditions)
    dispatch(setIsTermsAndCondtionChanged(false));
    dispatch(setIsEditableTermsAndContionsEnabled(false))
  };

  const onUpdateTermsAndCondition = () => {
    logAnalyticsEvent(analyticsEvents.updateTermsAndConditions);
    dispatch(setIsTermsAndCondtionUpdated(true));
    dispatch(callToUpdateStoreTermsAndConditions());
  };

  const onClickEditHandler = () => {
    dispatch(setIsEditableTermsAndContionsEnabled(true))
  }

  const onCancelUpdatePermissions = () => {
    dispatch(setIsPermissionReset(true))
    dispatch(setIsPermissionChanged(false));
  }

  const onUpdatePermissions = () => {
    dispatch(callToUpdatePermissionsTabsList(permissionConfig))
    dispatch(setIsPermissionChanged(false));
  }
  const subTabs = getHideSubTabs(isStoreAdmin, isStoreAgent, userPermissions)

  React.useEffect(() => {
    if (tabName === 'admin' && !canViewEcommerceStatusMapping) {
      navigate(getAdminTabPath(subTabs), { replace: true });
    }
  }, [tabName, canViewEcommerceStatusMapping, navigate, subTabs]);

  const tabDetails = [
    {
      route: "/admin/manage-dealer-profile",
      label: "Store Profile",
      groups: ["globalAdmin", "admin"],
      isImpersonate: true,
      isAllowBoth: true,
      keyVal: 'storeProfile'
    },
    {
      route: "/admin/manage-users",
      label: "Users",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user"],
      isImpersonate: false,
      keyVal: 'users'
    },
    {
      route: "/admin/fflselect",
      label: "FFLSelect",
      groups: ["admin", "globalAdmin"],
      isImpersonate: true,
      isAllowBoth: true,
      keyVal: 'selectConfig'
    },
    {
      route: "/admin/blacklist-dealers",
      label: "Blacklist Dealers",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user"],
      isImpersonate: false,
      keyVal: 'blacklisted'
    },
    {
      route: "/admin/upload-preferred-dealers",
      label: "Preferred Dealers",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user", "preferredReports"],
      isImpersonate: false,
      keyVal: 'preferred'
    },
    {
      route: "/admin/upload-stocking-dealers",
      label: "Stocking Dealers",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user"],
      isImpersonate: false,
      keyVal: 'stocking'

    },
    {
      route: "/admin/manage-parameters",
      label: "Parameters",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user"],
      isImpersonate: false,
      keyVal: 'parameters'
    },
    {
      route: "/admin/preferred-dealers-report",
      label: "Preferred Dealers Report",
      groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user", "preferredReports"],
      isImpersonate: false,
      keyVal: 'preferedReport'
    },
    {
      route: "/admin/manage-terms-and-conditions",
      label: "Terms & Conditions",
      groups: ["admin", "agent", "globalAdmin"],
      isImpersonate: true,
      isAllowBoth: true,
      keyVal: 'termsConditions'
    },
    {
      route: "/admin/permissions",
      label: "Permissions",
      groups: ["globalAdmin",],
      isImpersonate: true,
      keyVal: 'permissions',
      // groups: ["admin", "agent", "globalAdmin", "globalOperations", "myffl_user", "preferredReports"],
    },
    {
      route: "/admin/enriched-webhook",
      label: "Webhooks",
      groups: ["globalAdmin", "admin"],
      isImpersonate: true,
      isAllowBoth: true,
      keyVal: 'customWebhook'
    },
    {
      route: "/admin/admin",
      label: "Admin",
      groups: ["globalAdmin"],
      isImpersonate: true,
      isAllowBoth: false,
      keyVal: 'ecommerceStatusMapping'
    },
    {
      route: "/admin/ffl-stripe-configuration",
      label: "FFL Stripe Configuration",
      groups: [ "globalAdmin"],
      isImpersonate: true,
      isAllowBoth: false,
      keyVal: 'fflStripeConfiguration'
    },
  ];

  const visibleTabDetails = React.useMemo(() => {
    return tabDetails
      .filter((tab) => {
        if (tab.keyVal === 'ecommerceStatusMapping' && !canViewEcommerceStatusMapping) {
          return false;
        }
        if (isImpersonating && tab.isImpersonate) return true;
        if ((!tab.isImpersonate || tab?.isAllowBoth) && tab.groups.includes(currentUserGroup)) return true;
        return false;
      })
      .filter((tab) => !subTabs?.includes(tab?.keyVal));
  }, [canViewEcommerceStatusMapping, currentUserGroup, isImpersonating, subTabs]);

  const getTabName = () => {
    console.log({ tabName, isImpersonating, isPreferredReportsRole, subTabs, adminTabNames })
    if (isImpersonating)
      return Number(adminTabNames[tabName as string]);
    if (isPreferredReportsRole)
      return Number(adminTabNamesForPreferredReportsAdmin[tabName as string]);
    if (subTabs && subTabs.length > 0) {
      const activeRoute = `/admin/${tabName ?? ''}`;
      const computedIndex = visibleTabDetails.findIndex((tab) => tab.route === activeRoute);
      return computedIndex >= 0 ? computedIndex : 0;
    }
    return Number(adminTabNamesForStoreAdmin[tabName as string])
  }

  const renderTabs = React.useMemo(() => {
    return visibleTabDetails?.map((tab) => <Link to={tab.route}>
      <Tab className="tabs-box">{tab.label}</Tab>
    </Link>);
  }, [visibleTabDetails]);

  return (
    <Tabs
      index={getTabName()}
      position="relative"
      height={'100%'}
      variant="unstyled"
      onChange={(e: number) => {
        setRefetch(e);
      }}
    >
      <TabList>
        <Box className='tabs-box-container-wrapper'>{renderTabs}</Box>
        <Box className='tabs-action-container'>
        {tabName === 'blacklist-dealers' && (
          <Button className="add-blacklist-btn" onClick={onOpen}>
            {' '}
            + Add to blacklist
          </Button>
        )}
        {tabName === 'fflselect' && fflSelectTab === 0 && (
          <Box className="filter-action-container">
            <Button
              colorScheme="blue"
              background="#ffffff"
              color="#0C1E46"
              border="1px solid #0C1E46"
              padding="8px 11px"
              marginRight="20px"
              isDisabled={!isFilterConfigChanged}
              onClick={onCancelFilterChanges}
            >
              {constants.CANCEL_LABEL}
            </Button>
            <Button
              colorScheme="blue"
              background="#0C1E46"
              padding="8px 20px"
              isLoading={isUpdatingFilterConfig}
              isDisabled={!isFilterConfigChanged}
              onClick={onUpdateFilterConfig}
            >
              {constants.SAVE_TEXT}
            </Button>
          </Box>
        )}
        {tabName === 'manage-terms-and-conditions' && (
          <Box className="filter-action-container">
            {!isEditabledTermsAndConditionsEnabled ? (
              <div>
                <Button
                  colorScheme="blue"
                  background="#0C1E46"
                  padding="8px 20px"
                  onClick={onClickEditHandler}
                >
                  {constants.EDIT_TEXT}
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  colorScheme="blue"
                  background="#ffffff"
                  color="#0C1E46"
                  border="1px solid #0C1E46"
                  padding="8px 11px"
                  marginRight="20px"
                  onClick={onCancelTermsAndCondition}
                >
                  {constants.CANCEL_LABEL}
                </Button>
                <Button
                  colorScheme="blue"
                  background="#0C1E46"
                  padding="8px 20px"
                  isLoading={isTermsAndConditionUpdated}
                  isDisabled={!isTermsAndConditionChanged}
                  onClick={onUpdateTermsAndCondition}
                >
                  {constants.SAVE_TEXT}
                </Button>
              </div>
            )}
          </Box>
        )}
        {tabName === 'permissions' && isImpersonating && (
          <Box className="filter-action-container">
            <Button
              colorScheme="blue"
              background="#ffffff"
              color="#0C1E46"
              border="1px solid #0C1E46"
              padding="8px 11px"
              marginRight="20px"
              isDisabled={isPermissionsListLoading || isPermissionsUpdateLoading || !isPermissionChanged}
              onClick={onCancelUpdatePermissions}
            >
              {constants.CANCEL_LABEL}
            </Button>
            <Button
              colorScheme="blue"
              background="#0C1E46"
              padding="8px 20px"
              isLoading={isPermissionsUpdateLoading}
              isDisabled={!isPermissionChanged || isPermissionsListLoading || isPermissionsUpdateLoading}
              onClick={onUpdatePermissions}
            >
              {constants.SAVE_TEXT}
            </Button>
          </Box>
        )}
        </Box>
      </TabList>
      <TabList></TabList>
      <hr style={{ margin: '25px 0 10px 0' }} />
      {isPreferredReportsRole ?
        <TabPanels>
          <TabPanel>
            <StoreProfile />
          </TabPanel>
          <TabPanel>
            <PreferredDealersReport />
          </TabPanel>
        </TabPanels>
        :
        !isImpersonating ?
          <TabPanels>
            <TabPanel>
              <ManageDealerProfile isStoreAdmin={isStoreAdmin} doRefresh={refetch} />
            </TabPanel>
            {!subTabs.includes('users') && (
              <TabPanel sx={{ paddingBottom: '0' }}>
                <ManageUsers doRefresh={refetch} />
              </TabPanel>
            )}
            {!subTabs.includes('selectConfig') && (
              <TabPanel sx={{ padding: '0' }}>
                <Tabs
                  position="relative"
                  variant="unstyled"
                  onChange={(e: number) => {
                    setFFLSelectTab(e);
                  }}
                >
                  <TabList>
                    <Tab className="tab-title">FFL Filters Configuration</Tab>
                  </TabList>
                  <TabIndicator
                    mt="-1.5px"
                    height="2px"
                    bg="#0c1e46"
                    borderRadius="1px"
                  />
                  <TabPanels>
                    <TabPanel sx={{ padding: '0' }}>
                      <FFLSelectFiltersConfiguration
                        callAPI={callAPI}
                        setCallAPI={setCallAPI}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </TabPanel>
            )}
            {!subTabs.includes('blacklisted') && (
              <TabPanel sx={{ paddingBottom: '0' }}>
                <BlacklistDealers
                  isOpen={isOpen}
                  onClose={onClose}
                  doRefresh={refetch}
                />
              </TabPanel>
            )}
            {!subTabs.includes('preferred') && (
              <TabPanel>
                <StoreProfile />
              </TabPanel>
            )}
            {!subTabs.includes('stocking') && (
              <TabPanel>
                <StockingDealers />
              </TabPanel>
            )}
            {!subTabs.includes('parameters') && (
              <TabPanel>
                <ManageParameters doRefresh={refetch} />
              </TabPanel>
            )}
            {!subTabs.includes('preferedReport') && (
              <TabPanel>
                <PreferredDealersReport />
              </TabPanel>
            )}
            {!subTabs.includes('termsConditions') && (
              <TabPanel>
                <ManageTermsAndConditions setValue={setEditorValue} value={editorValue}  />
              </TabPanel>
            )}
            {!subTabs.includes('customWebhook') && (
              <TabPanel>
                <CustomWebhook />
              </TabPanel>
            )}
            {canViewEcommerceStatusMapping && !subTabs.includes('ecommerceStatusMapping') && (
              <TabPanel>
                <EcommerceStatusMapping />
              </TabPanel>
            )}
          </TabPanels>
          :
          <TabPanels>
            <TabPanel>
              <ManageDealerProfile isStoreAdmin={isStoreAdmin} doRefresh={refetch} />
            </TabPanel>
            <TabPanel sx={{ paddingBottom: '0' }}>
              <ManageUsers doRefresh={refetch} />
            </TabPanel>
            <TabPanel sx={{ padding: '0' }}>
              <Tabs
                position="relative"
                variant="unstyled"
                onChange={(e: number) => {
                  setFFLSelectTab(e);
                }}
              >
                <TabList>
                  <Tab className="tab-title">FFL Filters Configuration</Tab>
                  <Tab className="tab-title">FFL Store Configuration</Tab>
                </TabList>
                <TabIndicator
                  mt="-1.5px"
                  height="2px"
                  bg="#0c1e46"
                  borderRadius="1px"
                />
                <TabPanels>
                  <TabPanel sx={{ padding: '0' }}>
                    <FFLSelectFiltersConfiguration
                      callAPI={callAPI}
                      setCallAPI={setCallAPI}
                    />
                  </TabPanel>
                  <TabPanel>
                    <FFLSelect doRefresh={refetch} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </TabPanel>
            <TabPanel sx={{ paddingBottom: '0' }}>
              <BlacklistDealers
                isOpen={isOpen}
                onClose={onClose}
                doRefresh={refetch}
              />
            </TabPanel>
            <TabPanel>
              <StoreProfile />
            </TabPanel>
            <TabPanel>
              <StockingDealers />
            </TabPanel>
            <TabPanel>
              <ManageParameters doRefresh={refetch} />
            </TabPanel>
            <TabPanel>
              <PreferredDealersReport />
            </TabPanel>
            <TabPanel>
              <ManageTermsAndConditions setValue={setEditorValue} value={editorValue} />
            </TabPanel>
            <TabPanel>
              <Permissions />
            </TabPanel>
            <TabPanel>
              <CustomWebhook />
            </TabPanel>
            {canViewEcommerceStatusMapping && (
              <TabPanel>
                <EcommerceStatusMapping />
              </TabPanel>
            )}
            <TabPanel>
              <FFLStripeConfiguration />
            </TabPanel>
          </TabPanels>}
    </Tabs>
  );
}

export default StoreAdmin;
